import {ROUTES} from '../../config/index.js'

export const getInitialProps = async ({routeInfo, context: {i18n, domain}}) => {
  const {
    location: {pathname: path}
  } = routeInfo

  const config = domain.get('config')
  const {TECHNICAL_DETAILS_PATH_PATTERN} = config.get('page')
  const {
    ERRORS: {GetMarketedMakesVehiclesError}
  } = config.get('COMMON')

  const {culture} = i18n

  let serverErrors = []

  const getMakes = async () => {
    try {
      return await domain
        .get('get_marketed_makes_vehicles_use_case')
        .execute({urlPrefix: TECHNICAL_DETAILS_PATH_PATTERN})
    } catch (error) {
      serverErrors = [...serverErrors, error]
    }
  }

  const initialTechnicalDetailsHomeFactory = async () => {
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    const [[seoDataError, seoDataResponse], makesList, [, breadcrumb]] = await Promise.all([
      domain.get('get_seo_data_use_case').execute({culture, pageName}),
      getMakes(),
      domain.get('get_breadcrumbs_breadcrumb_use_case').execute({pageName})
    ])

    const seoData = seoDataResponse || {}

    const hasCriticalServerErrors = serverErrors.some(
      serverError => serverError instanceof GetMarketedMakesVehiclesError
    )

    return {
      ...(hasCriticalServerErrors && {__HTTP__: {redirectTo: ROUTES.HOME}}),
      breadcrumb,
      h1: seoData.h1,
      helmet: seoData.head,
      pageName,
      serverErrors,
      pageErrors: {
        seoDataError
      },
      ...(makesList && {...makesList})
    }
  }

  const initialTechnicalDetailsHome = await initialTechnicalDetailsHomeFactory()

  return initialTechnicalDetailsHome
}
